'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Divider = props => (React__default.default.createElement("svg", { "data-name": "Calque 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11.34 12.77", width: "1em", height: "1em", ...props },
    React__default.default.createElement("rect", { x: 5.19, y: 0.18, width: 0.96, height: 12.41, rx: 0.48, transform: "rotate(19.03 5.67 6.38)", fill: "#c9d1df" })));

exports.Divider = Divider;
//# sourceMappingURL=Divider.js.map
